import React from "react";
import CrudManager from "../../common/CrudManager";
import { Tag, Edit2, Trash2, Calendar } from "lucide-react";

const TagManager = ({ onClose }) => {
  const fields = [
    {
      name: "name",
      label: "Tag Name",
      type: "text",
      placeholder: "e.g., Frontend, Backend, Urgent",
      required: true,
    },
  ];

  const formatCreateData = (formData) => ({ name: formData.name.trim() });
  const formatUpdateData = (formData) => ({ name: formData.name.trim() });

  const renderItem = (tag, onEdit, onDelete) => (
    <div className="flex items-center justify-between w-full group">
      <div className="flex items-center space-x-4">
        {/* Visual Icon with subtle glow */}
        <div className="w-12 h-12 bg-subidha-blue/5 rounded-2xl flex items-center justify-center border border-subidha-blue/10 group-hover:bg-subidha-blue group-hover:text-white transition-all duration-300">
          <Tag className="w-5 h-5 text-subidha-blue group-hover:text-white" />
        </div>

        <div>
          <h3 className="text-sm font-black text-slate-900 uppercase tracking-tight">
            {tag.name}
          </h3>
          <div className="flex items-center text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-1">
            <Calendar className="w-3 h-3 mr-1" />
            {new Date(tag.createdAt).toLocaleDateString()}
          </div>
        </div>
      </div>

      <div className="flex items-center space-x-1">
        {onEdit && (
          <button
            onClick={() => onEdit(tag)}
            className="p-2.5 text-slate-400 hover:text-subidha-blue hover:bg-subidha-blue/10 rounded-xl transition-all"
            title="Edit Tag"
          >
            <Edit2 className="w-4 h-4" />
          </button>
        )}
        {onDelete && (
          <button
            onClick={() => onDelete(tag)}
            className="p-2.5 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-xl transition-all"
            title="Delete Tag"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );

  return (
    <CrudManager
      title="Manage Tags"
      apiEndpoint="/tags"
      fields={fields}
      renderItem={renderItem}
      onClose={onClose}
      icon={Tag}
      emptyMessage="No tags yet. Create your first tag!"
      formatCreateData={formatCreateData}
      formatUpdateData={formatUpdateData}
    />
  );
};

export default TagManager;
